The page of position openings and their corresponding cursors.

This list may be empty.
